import { Chip, useMediaQuery } from '@mui/material';
import { useThemeContext } from '../../../contexts/BaseThemeContextProvider';

type BadgeLabelConcentrationProps = {
  positionY: number;
  barX: number;
  barWidth: number;
  value: number | string;
  labelColor: string;
};

export const BadgeLabelConcentration = ({
  positionY,
  barX,
  barWidth,
  value,
  labelColor,
}: BadgeLabelConcentrationProps) => {
  const { theme } = useThemeContext();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));
  // as we use the same version for desktop and mobile and the space for the chart is different
  // we need to make adjustments, if this needs more customization later
  // we can accept all those parameters as props
  let widthSize = isSmallDevice ? 90 : 100;
  let leftLabelSpace = isSmallDevice ? 7 : 3;
  let fontSize = isSmallDevice ? '18px' : '12px';

  const labelX = barX + barWidth + leftLabelSpace;
  const finalYPosition = positionY - 15;

  return (
    <>
      <foreignObject x={labelX} y={finalYPosition} width={widthSize} height={40}>
        <Chip
          label={value}
          sx={{
            bgcolor: labelColor,
            color:
              theme.custom.report.details.compoundCardsList.compoundDetailsChart.renderBarChart.barChart
                .badgeLabelConcentrationColor,
            '& .MuiChip-label': {
              fontSize: fontSize,
            },
          }}
        />
      </foreignObject>
    </>
  );
};
